import trimEnd from 'lodash-es/trimEnd';

/**
 * Remove leading and trailing whitespace along with the `chars` at the end
 * @param value The value to trim
 * @param chars The trailing character(s) to remove
 */
export const trimWhitespaceAndTrailing = (value: string | undefined, chars: string) => trimEnd(value?.trim(), chars);
